import PropTypes from 'prop-types'

import { userDetailsPropType } from '../../users/prop-types'

const dishTimestampsPropType = PropTypes.shape({
  updatedBy: userDetailsPropType,
  updatedAt: PropTypes.string,
  createdBy: userDetailsPropType,
  createdAt: PropTypes.string,
  tierOneDoneAt: PropTypes.string,
  tierOneDoneBy: userDetailsPropType,
  curatedBy: userDetailsPropType,
  curatedAt: PropTypes.string,
  qadBy: userDetailsPropType,
  qcdBy: userDetailsPropType,
  qadAt: PropTypes.string,
  qcdAt: PropTypes.string,
  lockedAt: PropTypes.string,
  miscAndChoiceUpdatedAt: PropTypes.string,
  dishTypeUpdatedAt: PropTypes.string,
  courseTypeUpdatedAt: PropTypes.string,
  dietsUpdatedAt: PropTypes.string,
  allergensUpdatedAt: PropTypes.string,
  ingredientsUpdatedAt: PropTypes.string,
  isPublishedUpdatedAt: PropTypes.string,
  lastModifiedByTierOneAt: PropTypes.string,
  lastModifiedByCuratorAt: PropTypes.string,
  lastModifiedByQaAt: PropTypes.string,
  lastModifiedByQcAt: PropTypes.string,
  lastRestSuggestionsAt: PropTypes.string,
  lastPubSubSuggestionsAt: PropTypes.string,
  autoeatUpdatedAt: PropTypes.string,
  lastModifiedByTierOne: userDetailsPropType,
  lastModifiedByCurator: userDetailsPropType,
  lastModifiedByQa: userDetailsPropType,
  lastModifiedByQc: userDetailsPropType,
})

export default dishTimestampsPropType
